/** Free writing practice — the learner's own German, marked by the coach.
 *
 * The same engine as the exam writing task, with no exam behind it: the
 * learner picks a level, writes a paragraph, and gets it back with a score,
 * corrections and recommendations.
 */
import { request } from "./http";
import type { WritingFeedback, WritingQuota } from "./exams";

export interface FreeWriting {
  id: string;
  created_at: string | null;
  word_count: number;
  score_percent: number | null;
  /** Same shape the exam coach returns, so one view renders both. In free
   *  mode `task_points` is empty — there were no set points to address. */
  feedback: WritingFeedback | null;
  level: string | null;
  topic: string | null;
  text: string;
}

export interface FreeWritingState {
  configured: boolean;
  quota: WritingQuota | null;
  levels: string[];
  submissions: FreeWriting[];
}

export function freeWritingState(): Promise<FreeWritingState> {
  return request("/writing/free");
}

export function submitFreeWriting(
  text: string,
  level: string,
  topic?: string,
): Promise<FreeWriting & { quota: WritingQuota }> {
  return request("/writing/free", {
    method: "POST",
    body: { text, level, topic: topic || null },
  });
}
